import React from "react";
import prepareGif from "~/src/assets/overviews/breachrx/1-prepare.gif";
import respondGif from "~/src/assets/overviews/breachrx/2-respond.gif";
import trackManageGif from "~/src/assets/overviews/breachrx/3-track-manage.gif";
import actionsPrioritizeGif from "~/src/assets/overviews/actions/1-prioritize.gif";
import actionsActGif from "~/src/assets/overviews/actions/2-act.gif";
import actionsAccomplishGif from "~/src/assets/overviews/actions/3-accomplish.gif";
import incidentCreateGif from "~/src/assets/overviews/incident/1-create.gif";
import incidentActGif from "~/src/assets/overviews/incident/2-act.gif";
import incidentViewGif from "~/src/assets/overviews/incident/3-view.gif";
import complianceComplyGif from "~/src/assets/overviews/compliance/1-comply.gif";
import compliancePlanGif from "~/src/assets/overviews/compliance/2-plan.gif";
import obligationsComplyGif from "~/src/assets/overviews/obligations/1-comply.gif";
import obligationsActGif from "~/src/assets/overviews/obligations/2-act.gif";
import obligationsCustomizeGif from "~/src/assets/overviews/obligations/3-customize.gif";
import tasksReduceRiskGif from "~/src/assets/overviews/tasks/1-reduce-risk.gif";
import tasksOrganizeGif from "~/src/assets/overviews/tasks/2-organize.gif";
import tasksCustomizeGif from "~/src/assets/overviews/tasks/3-customize.gif";
import playbooksPrepareGif from "~/src/assets/overviews/playbooks/1-prepare.gif";
import playbooksOrganizeGif from "~/src/assets/overviews/playbooks/2-organize.gif";
import reportsTrackGif from "~/src/assets/overviews/reports/1-track.gif";
import reportsMeasureGif from "~/src/assets/overviews/reports/2-measure.gif";
import reportsAssessGif from "~/src/assets/overviews/reports/2_5-assess.gif";
import dataCreateGif from "~/src/assets/overviews/data/1-create.gif";
import dataCustomizeGif from "~/src/assets/overviews/data/2-customize.gif";
import dataReorderGif from "~/src/assets/overviews/data/3-reorder.gif";
import datasetsCreateGif from "~/src/assets/overviews/datasets/1-create.gif";
import datasetsViewUpdateGif from "~/src/assets/overviews/datasets/2-view-update.gif";
import datasetsAssessRiskGif from "~/src/assets/overviews/datasets/3-assess-risk.gif";

export const overviewData = {
  dashboard: [
    {
      title: "Prepare",
      content: (
        <img src={prepareGif} />
      ),
      description: `Know exactly what to do when an incident occurs by adding obligations, 
      adjusting regulations, and getting playbooks into place. Everything is customizable 
      in the BreachRx platform, so adjust our best practices to align with your internal 
      processes.`,
    },
    {
      title: "Respond",
      content: (
        <img src={respondGif} />
      ),
      description: `Launch, execute, and collaborate on your response to events and incidents 
      seamlessly. Know what actions are on your to-do list, along with their deadlines. The 
      BreachRx platform is your command center and central system of record for your team.`,
    },
    {
      title: "Track & Manage",
      content: (
        <img src={trackManageGif} />
      ),
      description: `Leverage reports and dashboards to track progress, gather metrics, identify 
      trends, and report out to everyone from leadership to regulators.`,
    },
  ],
  actions: [
    {
      title: "Prioritize",
      content: (
        <img src={actionsPrioritizeGif} />
      ),
      description: `Know exactly what actions to take during one or more incidents, which tasks 
      need to take priority, and when they're due.`,
    },
    {
      title: "Act",
      content: <img src={actionsActGif} />,
      description: `Easily keep a record of the activities you take in a central location keeping 
      an automated record of your work. Collaborate with others on your team on a task by task 
      basis.`,
    },
    {
      title: "Accomplish",
      content: (
        <img src={actionsAccomplishGif} />
      ),
      description: `Reassign tasks to others on your team as needed. Close the task when complete 
      or delete it if it's no longer needed.`,
    },
  ],
  incidents: [
    {
      title: "Create",
      content: (
        <img src={incidentCreateGif} />
      ),
      description: `Get started by creating a new incident with either the incident wizard or the 
      incident add form. Include whatever incident attributes you know — you can always update or 
      expand them later. Or start with a playbook with templatized best practices and hit the 
      ground running when an incident occurs.`,
    },
    {
      title: "Act",
      content: <img src={incidentActGif} />,
      description: `Stay on top of incident progress, edit incident details, execute and assign 
        tasks, communicate in a privileged space, and add evidence, all while an audit log 
        automatically tracks your team's execution. Refer to related incidents from the past to 
        accelerate your response.`,
    },
    {
      title: "View",
      content: <img src={incidentViewGif} />,
      description: `Review ongoing incidents, see their status, and approve any started by your 
        team. Reach into the archive as needed for training and get new team members up to 
        speed.`,
    },
  ],
  compliance: [
    {
      title: "Comply",
      content: (
        <img src={complianceComplyGif} />
      ),
      description: `Comply more rapidly with incident reporting and response requirements in 
      popular cybersecurity & privacy frameworks including SOC 2, ISO 27001, NIST CSF, CIS Controls,
      and more.`,
    },
    {
      title: "Plan",
      content: (
        <img src={compliancePlanGif} />
      ),
      description: `Demonstrate to customers, partners, and regulators that your organization 
      has a sophisticated cybersecurity & data protection program with a cutting-edge comprehensive 
      incident response plan and policy.`,
    },
  ],
  obligations: [
    {
      title: "Comply",
      content: (
        <img src={obligationsComplyGif} />
      ),
      description: `Know what tasks you need to accomplish to maintain regulatory compliance with 
      BreachRx Privacy Intelligence. Regulations are kept up to date with the latest developments.`,
    },
    {
      title: "Act",
      content: (
        <img src={obligationsActGif} />
      ),
      description: `Hit the ground running with the actions you need to take for your contracts, 
      plans, policies, and other obligations that match the details of your incident.`,
    },
    {
      title: "Customize",
      content: (
        <img src={obligationsCustomizeGif} />
      ),
      description: `Adapt existing best-practice obligations and their tasks to your organization 
      and team. Add new obligations to cover your program requirements.`,
    },
  ],
  tasks: [
    {
      title: "Reduce Risk",
      content: (
        <img src={tasksReduceRiskGif} />
      ),
      description: `Know what tasks you need to accomplish to reduce regulatory risk with 
      BreachRx Privacy Intelligence. Tasks are kept up to date with their obligations.`,
    },
    {
      title: "Organize",
      content: <img src={tasksOrganizeGif} />,
      description: `BreachRx keeps tasks dynamically up to date with changes in best practices and 
      obligations. Easily stay on top of your task library: edit, duplicate, promote, and delete 
      tasks as needed to stay prepared.`,
    },
    {
      title: "Customize",
      content: (
        <img src={tasksCustomizeGif} />
      ),
      description: `Adapt existing best-practice tasks to your organization and team. Add new 
      obligations to cover your program requirements.`,
    },
  ],
  playbooks: [
    {
      title: "Prepare",
      content: (
        <img src={playbooksPrepareGif} />
      ),
      description: `Get playbooks into place for the types of events your organization faces on a 
      recurring basis. Playbooks automatically guide you with the exact actions to take for a 
      variety of different incidents.`,
    },
    {
      title: "Organize",
      content: (
        <img src={playbooksOrganizeGif} />
      ),
      description: ` Easily stay on top of your playbook library: draft, edit, disable, archive, 
      and delete playbooks as needed to stay prepared. BreachRx keeps playbooks dynamically up to 
      date with changes in best practices and obligations.`,
    },
    {
      title: "Accelerate",
      content: <img src="/overviews/playbooks/3-accelerate.gif" />,
      description: `Kick off an incident using a playbook so you know you're getting the best 
      guidance in the market and can return to business as usual sooner.`,
    },
  ],
  reports: [
    {
      title: "Track",
      content: <img src={reportsTrackGif} />,
      description: `Track the execution of each incident response with automatically-generated, 
      detailed and factual reports that can be given to peers, leadership, board membership, 
      regulators, and other concerned parties while protecting privilege.`,
    },
    {
      title: "Measure",
      content: (
        <img src={reportsMeasureGif} />
      ),
      description: `Collect metrics on incident response program execution over any period of time, 
      identify trends in incident occurrence, and get a top-level view of all active incidents in 
      real time.`,
    },
    {
      title: "Assess",
      content: (
        <img src={reportsAssessGif} />
      ),
      description: `Use the industry's first risk assessment for regulatory, contractual, and other
      requirements. Determine the potential impacts of various types of incidents with one or 
      more datasets, and identify potential changes to datasets that would reduce that impact.`,
    },
  ],
  dataOptions: [
    {
      title: "Create",
      content: <img src={dataCreateGif} />,
      description: `Add custom conditions that can be used to filter down to the exact actions 
      your team needs to take based on their use as incident attributes. Create new incident types, 
      severities, phases, and other underlying data to match your existing processes.`,
    },
    {
      title: "Customize",
      content: <img src={dataCustomizeGif} />,
      description: `Update existing data elements and their descriptions, add options for 
      lists, and customize their appearance.`,
    },
    {
      title: "Reorder",
      content: <img src={dataReorderGif} />,
      description: `Change the order of phases and severities to align them with how your team 
      operates.`,
    },
  ],
  datasets: [
    {
      title: "Create",
      content: (
        <img src={datasetsCreateGif} />
      ),
      description: `Create a dataset and capture the attributes relevant to a database, data
      warehouse, or other data store(s). Use the dataset to save time when starting incidents
      or creating playbooks. Datasets allow you to easily assess the risk of impacts from 
      incidents in our risk assessment report.`,
    },
    {
      title: "View & Update",
      content: (
        <img src={datasetsViewUpdateGif} />
      ),
      description: `Review and update each dataset, its specific attributes, and the geography 
      related to its data.`,
    },
    {
      title: "Assess Risk",
      content: (
        <img src={datasetsAssessRiskGif} />
      ),
      description: ` Capture an individual assessment of the risks of impacts from the
      potential involvement of each dataset in incidents.`,
    },
  ],
};
